module.exports = __webpack_public_path__ + "img/ico_play.c9d48309.svg";